import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Tag } from 'src/app/models/tag.model';
import { Video } from 'src/app/models/video.model';
import { TagsService } from 'src/app/services/tags.service';
import { UsersService } from 'src/app/services/users.service';
import { VideosService } from 'src/app/services/videos.service';
// import Swal from 'sweetalert2'
@Component({
  selector: 'search-page',
  templateUrl: './search-page.component.html',
  styleUrls: ['./search-page.component.scss']
})
export class SearchPageComponent implements OnInit {

  text: string = ''
  selector: string = ''
  showBlocked: boolean = false
  videos: Video[] = []
  tags: Tag[] = []
  dataLoaded: boolean = false
  // numOfPages: number = 1
  pageNum: number = 1
  tagsPageNum: number = 1
  loading: boolean
  tagsLoading: boolean = false
  finishedLoading: boolean
  tagsFinishedLoading: boolean = false
  //  resultsNum: number = 1
  firstTime = true
  disableCheckbox: boolean = false
  block: boolean = false
  userId = 0
  constructor(public router: Router, private route: ActivatedRoute, private usersService: UsersService,
    private videosService: VideosService, private tagsService: TagsService) {
  }

  ngOnInit(): void {
    this.usersService.currentUser.subscribe(
      u => this.userId = u.userId
    )
    this.route.queryParams
      .subscribe(params => {
        this.videos = []
        this.text = params['text']
        this.showBlocked = params['showBlocked']
        this.pageNum = 1
        this.tagsPageNum = 1
        this.tags = []
        this.dataLoaded = false
        this.searchVideos(true)
        // this.searchTags()

      },
        err => console.log(err))

  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    if (window.innerHeight + window.scrollY + 800 >= document.body.offsetHeight) {
      if (!this.loading && !this.finishedLoading)
        this.searchVideos(false)
    }
  }

  loadMoreTags() {
    if (!this.tagsLoading && !this.tagsFinishedLoading)
      this.searchTags()
  }


  searchVideos(searchTags: boolean) {
    this.loading = true
    this.block = false
    this.disableCheckbox = true
    this.videosService.searchVideos(this.text, this.selector, this.pageNum).subscribe((data) => {
      console.log('search result', data)
      // if (this.pageNum === 1)
      //   this.searchTags()
      if (data.videos.length === 0)
        this.finishedLoading = true
      if (searchTags)
        this.searchTags()
      this.videos.push(...data.videos)
      this.dataLoaded = true
      this.loading = false
      this.disableCheckbox = false
      this.pageNum = data.nextPage
    },
      e => {
        if (e.status == 403) {
          this.block = true
        }
      })
  }

  searchTags() {
    if (!this.tagsLoading && this.text !== undefined && this.text !== "") {
      this.tagsLoading = true
      this.tagsService.searchTags(this.text, this.tagsPageNum).subscribe(data => {
        console.log('search tags result', data.tags)
        if (data.tags.length < 8)
          this.tagsFinishedLoading = true
        this.tags.push(...data.tags)
        this.tagsPageNum = data.nextPage
        this.tagsLoading = false
      }, e => console.log(e))
    }
  }

}
